import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import store from "./store/index";
import "element-ui/lib/theme-chalk/index.css";
import { VueJsonp } from "vue-jsonp";
Vue.config.productionTip = false;
Vue.use(VueJsonp);
Vue.use(ElementUI);
import "./assets/icon/icon.css";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
